import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultMessageStartTransaction } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';

import { LogItemWrapper } from './log-item-wrapper.component';

export const StartTransactionComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultMessageStartTransaction(log.message)) {
    Logger.error(
      'Message is not of type OcppLogCallResultMessageStartTransaction',
      { log },
    );
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack direction="column" gap={GapEnum.M}>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-start-transaction-message-request.connector-id',
            )}
          </Text>{' '}
          {log.message.parameters.connectorId}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-start-transaction-message-request.id-tag',
            )}
          </Text>{' '}
          {log.message.parameters.idTag}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-start-transaction-message-request.status',
            )}
          </Text>{' '}
          {log.message.result.idTagInfo?.status ?? '-'}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-start-transaction-message-request.transaction-id',
            )}
          </Text>{' '}
          {log.message.result.transactionId}
        </Stack>
      </Stack>
    </LogItemWrapper>
  );
};
